import type { GetApiV1SchedulesComplianceByPatientIdData } from "../api";

/**
 * An IANA timezone as the API's `timezone` query params take it. Each endpoint
 * generates its own closed enum, but they share one list, so any one of them
 * types the rest.
 */
export type Timezone =
  GetApiV1SchedulesComplianceByPatientIdData["query"]["timezone"];

/** The browser's IANA timezone, typed as the API's `timezone` params take it. */
export function browserTimezone(): Timezone {
  return Intl.DateTimeFormat().resolvedOptions().timeZone as Timezone;
}
